import { z } from 'zod';
import { uuidSchema } from './common.js';
/**
 * Business Reviews persisted (Batch 2 of D-151; BP-12 Stakeholders subject, supplier QBR flavour) —
 * the review cadence per supplier: cadence, next date, agenda/minutes markdown and a small action
 * register. The agenda prefills client-side from live scorecard + contract + savings data. References
 * the supplier master by ID (D-100). Member-write, audited. Shapes shared by the API and the web app.
 */
export const reviewCadenceSchema = z.enum(['monthly', 'quarterly', 'annual']);
export const reviewActionSchema = z
    .object({
    title: z.string().trim().min(1).max(300),
    owner: z.string().trim().max(120).optional(),
    due: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected a date as YYYY-MM-DD').optional(),
    done: z.boolean(),
})
    .strict();
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected a date as YYYY-MM-DD');
export const businessReviewSchema = z.object({
    id: uuidSchema,
    supplierId: uuidSchema,
    title: z.string(),
    cadence: reviewCadenceSchema,
    nextDate: z.string().nullable(),
    agendaMd: z.string().nullable(),
    minutesMd: z.string().nullable(),
    actions: z.array(reviewActionSchema),
    isDemo: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/** POST /business-reviews — plan a review for a supplier (any member; audited). */
export const createBusinessReviewSchema = z
    .object({
    supplierId: uuidSchema,
    title: z.string().trim().min(1).max(200),
    cadence: reviewCadenceSchema.optional(),
    nextDate: isoDate.optional(),
    agendaMd: z.string().trim().max(16000).optional(),
})
    .strict();
/** PATCH /business-reviews/:id — update the plan, agenda, minutes or actions. */
export const patchBusinessReviewSchema = z
    .object({
    title: z.string().trim().min(1).max(200).optional(),
    cadence: reviewCadenceSchema.optional(),
    nextDate: isoDate.nullable().optional(),
    agendaMd: z.string().trim().max(16000).nullable().optional(),
    minutesMd: z.string().trim().max(16000).nullable().optional(),
    actions: z.array(reviewActionSchema).max(50).optional(),
})
    .strict();
//# sourceMappingURL=businessReviews.js.map